import '../../style/partner/invoices.css'

import { BeamSEO } from '../root/BeamSEO'
import CreateCentralBackendPartner from './CreateCentralBackendPartner'

export const CreatePartnerTabs = () => {
  return (
    <div>
      <BeamSEO title="Create Partner" />
      <div>{<CreateCentralBackendPartner />}</div>
    </div>
  )
}
